// @flow
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {fetchUser, activate} from '../../actions/activation';
import Activation from '../../components/Activation/Activation';

export type Props = {
  token: string,
  user: ?any,
  isActivated: boolean,
  fetchData: Function,
  error: ?any,
  tokenError: ?any,
  isFetching: boolean,
  onActivation: Function,
};

class ActivationContainer extends Component<Props> {
  props: Props;

  componentWillMount() {
    this.props.fetchData(this.props.token);
  }

  render() {
    const {
      token,
      onActivation,
      isActivated,
      user,
      isFetching,
      error,
      tokenError,
    } = this.props;

    return isActivated || !!tokenError ? (
      <Redirect to="/" />
    ) : (
      <Activation
        user={user}
        isLoading={isFetching}
        error={error}
        onActivation={values => onActivation(token, values)} />
    );
  }
}

const mapStateToProps = ({
  activation: {
    isActivated,
    user,
    isFetching,
    error,
    tokenError,
  },
}) => ({
  isActivated,
  isFetching,
  user,
  error,
  tokenError,
});

const mapDispatchToProps = dispatch => ({
  fetchData: token =>
    dispatch(fetchUser(token)),
  onActivation: (token, data) =>
    dispatch(activate(token, data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActivationContainer);



// WEBPACK FOOTER //
// ./src/containers/ActivationContainer/ActivationContainer.js